import ProjectPage from "../../components/ProjectPage";

// To add a real screenshot: drop the file into src/assets/, import it here
// (e.g. `import shot from "../../assets/arenav2-web.png";`), then add
// `src: shot` to the matching frame below.
export default function Arenav2() {
  return (
    <ProjectPage
      title="ArenaV2"
      category="Volunteer"
      // all copy below is draft — edit freely with the real ArenaV2 details
      tagline="Volunteer work on the ArenaV2 platform."
      body={[
        "I contribute to ArenaV2 as a volunteer developer, helping build and maintain the platform alongside the core team.",
        "Draft copy — replace with what ArenaV2 actually is, what you work on, and since when.",
      ]}
      art="linear-gradient(140deg, rgba(var(--text-rgb), 0.04) 0%, rgba(var(--accent-rgb), 0.16) 100%)"
      tech={["React", "JavaScript"]}
      features={[
        {
          title: "Volunteer contribution",
          desc: "Ongoing volunteer development work — describe your role here.",
        },
        {
          title: "Team collaboration",
          desc: "Working with the ArenaV2 team on features and fixes.",
        },
      ]}
      githubNote="Team repository"
      frames={[{ type: "web", label: "Web — screenshot coming" }]}
    />
  );
}
